export default __webpack_public_path__ + "static/media/essaim2.2cdd0248.jpg";